import { ArrowTurnDownRightIcon } from "@heroicons/react/24/outline";
import { useQuinn } from "../../QuinnContext.tsx";
import { QuinnCopy, type QuinnReplyTo } from "../../types";
import { useQuinnArtifactCanvas } from "./QuinnArtifactCanvasContext.tsx";

export function QuinnReplyToLink({ replyTo }: { replyTo: QuinnReplyTo }) {
    const canvas = useQuinnArtifactCanvas();
    const quinn = useQuinn();
    const open = canvas
        ? () => canvas.openArtifact(replyTo.artifactId)
        : quinn
          ? () => quinn.enterFullscreen(replyTo.artifactId)
          : null;
    const label = (
        <>
            <ArrowTurnDownRightIcon className="h-3.5 w-3.5 shrink-0" />
            <span className="text-gray-400">{QuinnCopy.About}</span>
            <span className="truncate font-medium">{replyTo.title}</span>
        </>
    );

    if (!open) {
        return <span className="flex max-w-[85%] items-center gap-1 text-xs text-gray-600">{label}</span>;
    }
    return (
        <button
            type="button"
            onClick={open}
            className="flex max-w-[85%] items-center gap-1 rounded-md px-1 text-xs text-gray-600 transition-colors hover:text-primary"
        >
            {label}
        </button>
    );
}
